import * as React from "react";
import type { SVGProps } from "react";
const SvgIconChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m8.29.4-.1.04c-.06.04-5 4.98-5.09 5.09q-.15.21-.15.47 0 .27.15.47l2.55 2.57c2.8 2.8 2.54 2.56 2.74 2.56q.1 0 .17-.03c.22-.11.32-.36.21-.59-.02-.04-.58-.6-2.49-2.52L3.82 6l2.46-2.46c1.9-1.91 2.47-2.48 2.49-2.52.1-.22.01-.48-.2-.58Q8.42.38 8.28.4"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconChevronLeft;
